import React from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import './App.css';
import App from './App';
import Historial from './Historial';
import TurnoVigente from './TurnoVigente';
import Verificacion from './Verificacion';
import Recorrido from './Recorrido';

ReactDOM.render(
  <Router>
    <Routes>
      <Route path="/trip/:tripId" element={<App />} />
      <Route path="/historial" element={<Historial />} />
      <Route path="/turno-vigente" element={<TurnoVigente />} />
      <Route path="/verificar/:aditamento" element={<Verificacion />} />
      {/* Mapa a pantalla completa (QR y enlace del ticket del pasajero) */}
      <Route path="/recorrido/:qrToken" element={<Recorrido />} />
      {/* Ruta para QR - ambos formatos */}
      <Route path="/viaje/:qrToken" element={<App />} />
      <Route path="/:qrToken" element={<App />} />
    </Routes>
  </Router>,
  document.getElementById('root')
);
